// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16a3e","content":"styles_content__1VnKw"};